import { flow } from 'lodash';
import DropDownGroup from './DropDownGroup';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(DropDownGroup);



// WEBPACK FOOTER //
// ../core/src/components/Dropdown/index.js